module.exports = __webpack_public_path__ + "static/img/fox-3b-header-lg.d7c7ce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/fox-3b-header-lg.jpg
// module id = 89
// module chunks = 0